import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

interface eventState {
  file: {};
}

const initialState: eventState = {
  file: {},
};

const uploadFileSlice = createSlice({
  name: "fileUpload",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(uploadFile.fulfilled, (state, action) => {
        state.file = action.payload;
      })
      .addCase(uploadSingleFile.fulfilled, (state, action) => {
        state.file = action.payload;
      });
  },
});

export default uploadFileSlice.reducer;

// Multiple File Upload
export const uploadFile = createAsyncThunk(
  "sas/uploadMultipleBlob",
  async (data: any) => {
    // get token
    let accessToken = localStorage.getItem("access_token");

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/sas/uploadMultipleBlob`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          // "Authorization": `Bearer ${accessToken}`
        },
      }
    );
    return response.data;
  }
);

// Single File Upload
export const uploadSingleFile = createAsyncThunk(
  "sas/uploadBlob",
  async (data: any) => {
    // get token
    let accessToken = localStorage.getItem("access_token");
    let formData = new FormData();
    formData.append("file", data[0]);

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/sas/uploadBlob`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  }
);

//Admin multiple file Upload
export const uploadAdminFiles = createAsyncThunk(
  "feedbackImages/adminUploadImage",
  async (data: any) => {
    let accessToken = localStorage.getItem("access_token");
    const userId = localStorage.getItem("userId");
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/feedbackImages/adminUploadImage/user/${userId}/event/${data.id}`,
      data.formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  }
);

//Admin multiple file Upload for Highlights
export const adminUploadHighlightsFiles = createAsyncThunk(
  "feedbackImages/adminUploadHighlightsImage",
  async (formData: any) => {
    let accessToken = localStorage.getItem("access_token");
    let shortId = localStorage.getItem("shortId");
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/feedbackImages/adminUploadImageForHighlights/${shortId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  }
);
